module.exports = "\n\n\n"


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/loading/loading.component.html
// module id = ../../../../../src/app/loading/loading.component.html
// module chunks = 0